import { call, fork, put, takeLatest } from 'redux-saga/effects';

import { submit } from 'redux-form';

import {
    errorRequestingAddress,
    receivedAddress,
    types as smartytypes
} from '../actions/smartystreets';
import {fetchAddressFromApi} from './smartystreets';

import {
    errorRequestingPrequal,
    receivedPrequal,
    types as prequaltypes
} from '../actions/prequal';

const uriSerialize = function(obj) {
  var str = [];
  for(var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

export const prequalStart = function *(action) {
    const { resolve, reject } = action.payload.promise;
    try {
        // @TODO street must be 'valid' and zip is required
        if(action.payload.request.verification_status == 'UNKNOWN') {
            const result0 = yield call(fetchAddressFromApi, {
                payload: {
                    address: {
                        street: action.payload.request.street,
                        zipcode: action.payload.request.zip
                    }
                }
            });
            if(!result0 || !result0.address) {
                // halt since user needs to see validation error
                // RECEIVED_ADDRESS action still fires
                // so the reducer handles updating the store
                reject('Potentially invalid address');
                return null;
            }
            else if(
                result0.is_secondary_suggested
                && !action.payload.request.secondary
            ) {
                // open the modal
                yield put({
                    type: 'SUGGEST_SECONDARY'
                });
                reject('Suggest secondary addr');
                return null;
            }
            else {
                // fall through & submit the prequal
            }
        } else if(
            action.payload.request.is_secondary_suggested
            && !action.payload.request.secondary
            && !action.payload.request.is_secondary_modal_visible
        ) {
            yield put({
                type: 'SUGGEST_SECONDARY'
            });
            reject('Suggest secondary addr');
            return null;
        }

        // resolve does stop_submit... why?
        // also should,a nd does, setsubmitsucceeded
        resolve();



        let requestBody = {
            auto_prequal: 1,
            street_address: action.payload.request.street,
            secondary: action.payload.request.secondary,
            zip_code: action.payload.request.zip,
            service_type: action.payload.request.service_type,
            smcity: action.payload.request.city || '',
            smstate: action.payload.request.state || '',
            coupon_code: action.payload.request.coupon_code || '',
            extra_data: document.querySelector('#extra_data').value || ''
        };

        const paramsList = new URLSearchParams(window.location.search);

        if(paramsList.has('utm_source')){
            requestBody['utm_source'] = paramsList.get('utm_source');
        }
        if(paramsList.has('utm_campaign')){
            requestBody['utm_campaign'] = paramsList.get('utm_campaign');
        }
        if(paramsList.has('utm_medium')){
            requestBody['utm_medium'] = paramsList.get('utm_medium');
        }
        
        var postForm = document.createElement('form');
        postForm.action = AVAILABILITY_URL;
        postForm.method = 'POST';

        for (const [key, value] of Object.entries(requestBody)) {
            console.log(`${key}: ${value}`);
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            postForm.appendChild(input);
        }

        document.body.appendChild(postForm);

        if (typeof gtag === "function") {
            gtag('event', 'sp_availability_prequal', {
                'event_category': 'sp_availability',
                'event_action': 'prequal'
            });
        } else {
            console.log("gtag is not defined");
        }

        postForm.submit();
        

        return true;
    } catch(error) {
        yield put(errorRequestingPrequal(error))
        console.log(error);
        reject(error);
        return null;
    }


}

function* watchStartPrequal() {
    yield [
        takeLatest(prequaltypes.REQUEST_PREQUAL, prequalStart),
    ];
}

export default function *prequalAddress () {
    yield [
        fork(watchStartPrequal)
    ];
}


// WEBPACK FOOTER //
// ./src/sagas/prequal.js